import React, { Component } from 'react';
import { Chart } from 'react-google-charts';
import theme from "../Theme";
import { translate } from "../../i18n/customI18nProvider";
import { gFormatCurrency } from '../../util';
import { cyan } from '@mui/material/colors';

const graph_colors_history = [
    theme.palette.primary.main,
    cyan[400]
];

const titleTextStyle = {
    color: theme.palette.primary.main,
    fontSize: 24,
    bold: true,
};

class ChargementsLineChart extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currencyCode: props.currencyCode,
            currencySymbol: props.currencySymbol
        };
    }

    render() {
        let currency = this.state.currencySymbol ? this.state.currencySymbol : this.state.currencyCode;
        const { history } = this.props;
        const credit = [[
            translate('custom.date'),
            translate('custom.loadings'),
            translate('custom.refunds')
        ]];
        let found = false;

        for (let i = 0; i < history.length; i++) {
            credit.push([
                new Date(history[i]["date"]),
                gFormatCurrency(history[i]["credit"]),
                gFormatCurrency(history[i]["checkout"])
            ]);
            if (history[i]["credit"] !== 0 || history[i]["checkout"] !== 0) {
                found = true;
            }
        }

        if (found) {
            let view = (
                <Chart
                    chartType="LineChart"
                    width="100%"
                    height="500px"
                    data={credit ?? []}
                    options={{
                        title: translate('custom.loadings'),
                        titleTextStyle,
                        vAxis: {
                            title: translate('custom.amount') + ' (' + currency + ')',
                            format: 'short'
                        },
                        hAxis: {
                            format: translate('custom.OPTIONS.chart_date_time_format')
                        },
                        colors: graph_colors_history,
                        backgroundColor: { fill: 'transparent' },
                        legend: { position: 'bottom' }
                    }}
                    graph_id="CreditsChart"
                />
            );

            return (
                <div className="breakBefore">
                    {view}
                </div>
            );
        }
        return null;
    }
}

export default ChargementsLineChart;